import * as actions from './permActions';
import {
  attRestoreSuspendResellerRule,
  editProfileBusinessChildRule,
  deactivateUserRule,
  resellersEditUserEmailRule,
  editUserGroupRule,
  editProfileResellerGroupRule,
  editAddressRule,
  createAddressRule,
} from './permissionsRules';
import PermsBuilder from './permsBuilder';
import {
  ADMIN,
  MANAGER,
  ADMIN_RO,
  AGENT,
  BUSINESS,
  BUSINESS_ADMIN,
  BUSINESS_AGENT,
  // USER,
  RESELLER,
  RESELLER_ADMIN,
  RESELLER_AGENT,
  // RESOLD_USER,
  BILLING,
  // TRAINEE,
} from './userGroups';

const { add, addRule, getPerms } = new PermsBuilder();

// main nav
add(actions.VIEW_CREATE_USER, [ADMIN, MANAGER, AGENT, BILLING, RESELLER]);
add(actions.VIEW_QUICK_PORT_OUTS, [
  ADMIN,
  ADMIN_RO,
  AGENT,
  BUSINESS,
  BUSINESS_ADMIN,
  BUSINESS_AGENT,
  RESELLER,
]);
add(actions.VIEW_BILLING_GROUP, [ADMIN, ADMIN_RO, MANAGER, AGENT, BILLING]);
add(actions.VIEW_PAYMENT_ARRANGEMENTS, [
  ADMIN,
  ADMIN_RO,
  MANAGER,
  AGENT,
  BILLING,
]);
add(actions.VIEW_ROLLING_ARRANGEMENTS, [
  ADMIN,
  ADMIN_RO,
  MANAGER,
  AGENT,
  BILLING,
]);
add(actions.VIEW_ARCHIVE_GROUP, [
  ADMIN,
  ADMIN_RO,
  MANAGER,
  AGENT,
  BILLING,
  BUSINESS,
  BUSINESS_ADMIN,
  BUSINESS_AGENT,
]);
add(actions.VIEW_DEVICE_PROTECTION_GROUP, [
  ADMIN,
  ADMIN_RO,
  MANAGER,
  AGENT,
  BILLING,
  BUSINESS,
  BUSINESS_ADMIN,
]);
add(actions.VIEW_ORDERS_GROUP, [
  ADMIN,
  ADMIN_RO,
  MANAGER,
  AGENT,
  BILLING,
  BUSINESS,
  BUSINESS_ADMIN,
]);
add(actions.VIEW_MASS_ACTIONS_GROUP, [ADMIN, MANAGER]);
add(actions.VIEW_REPORTING_GROUP, [ADMIN, MANAGER]);
add(actions.VIEW_ATT_SUBS_GROUP, [
  ADMIN,
  ADMIN_RO,
  MANAGER,
  AGENT,
  BILLING,
  BUSINESS,
  BUSINESS_ADMIN,
  BUSINESS_AGENT,
]);
add(actions.VIEW_SIMO_SUBS_GROUP, [
  ADMIN,
  ADMIN_RO,
  MANAGER,
  AGENT,
  BILLING,
  BUSINESS,
  BUSINESS_ADMIN,
  BUSINESS_AGENT,
]);
add(actions.VIEW_ALL_QUICK_SUBS, [
  ADMIN,
  ADMIN_RO,
  MANAGER,
  AGENT,
  BILLING,
  BUSINESS,
  BUSINESS_ADMIN,
  BUSINESS_AGENT,
]);
add(actions.VIEW_SEARCH_QUICK_SUBS, [
  ADMIN,
  ADMIN_RO,
  MANAGER,
  AGENT,
  BILLING,
  BUSINESS,
  BUSINESS_ADMIN,
  BUSINESS_AGENT,
]);
add(actions.VIEW_RESELLER_GROUP, [RESELLER]);

// top nav
add(actions.VIEW_TOP_SUBS_GROUPS, [
  ADMIN,
  ADMIN_RO,
  MANAGER,
  AGENT,
  BILLING,
  BUSINESS,
  BUSINESS_ADMIN,
  BUSINESS_AGENT,
]);
add(actions.VIEW_TOP_FEEDBACK, [ADMIN, ADMIN_RO, MANAGER, AGENT, BILLING]);

// user
add(actions.VIEW_USER_CREDIT, [
  ADMIN,
  ADMIN_RO,
  MANAGER,
  AGENT,
  BILLING,
  BUSINESS,
  BUSINESS_ADMIN,
]);
add(actions.VIEW_USER_LOGS, [
  ADMIN,
  ADMIN_RO,
  MANAGER,
  AGENT,
  BILLING,
  BUSINESS,
  BUSINESS_ADMIN,
  BUSINESS_AGENT,
]);
add(actions.VIEW_USER_PREACTIVATION, [
  ADMIN,
  ADMIN_RO,
  MANAGER,
  AGENT,
  BILLING,
  BUSINESS,
  BUSINESS_ADMIN,
  BUSINESS_AGENT,
]);
add(actions.VIEW_USER_ROLLING_PAYMENTS, [
  ADMIN,
  ADMIN_RO,
  MANAGER,
  AGENT,
  BILLING,
  BUSINESS,
  BUSINESS_ADMIN,
]);
add(actions.VIEW_USER_LOGIN_DEVICES, [ADMIN, MANAGER]);
add(actions.VIEW_USER_RATE_CARD, [
  ADMIN,
  ADMIN_RO,
  MANAGER,
  AGENT,
  BILLING,
  BUSINESS,
  BUSINESS_ADMIN,
]);
add(actions.EDIT_USER_PROFILE, [
  ADMIN,
  MANAGER,
  AGENT,
  BILLING,
  BUSINESS,
  BUSINESS_ADMIN,
  RESELLER,
  RESELLER_ADMIN,
  RESELLER_AGENT,
]);
addRule(actions.EDIT_USER_PROFILE, editProfileBusinessChildRule);
addRule(actions.EDIT_USER_PROFILE, editProfileResellerGroupRule);
add(actions.EDIT_USER_EMAIL, [
  ADMIN,
  MANAGER,
  AGENT,
  BILLING,
  RESELLER,
  RESELLER_ADMIN,
  RESELLER_AGENT,
]);
addRule(actions.EDIT_USER_EMAIL, resellersEditUserEmailRule);
add(actions.EDIT_USER_GROUP, [
  ADMIN,
  MANAGER,
  RESELLER,
  RESELLER_ADMIN,
  RESELLER_AGENT,
]);
addRule(actions.EDIT_USER_GROUP, editUserGroupRule);
add(actions.DEACTIVATE_USER, [ADMIN, RESELLER, RESELLER_ADMIN]);
addRule(actions.DEACTIVATE_USER, deactivateUserRule);
add(actions.UPDATE_CREATOR, [ADMIN, MANAGER]);
add(actions.CHANGE_AUTOPAY, [ADMIN, MANAGER, AGENT, BUSINESS, BUSINESS_ADMIN]);
add(actions.CHANGE_TAX_EXEMPT, [ADMIN]);
add(actions.CHANGE_PLAN_FEE_EXEMPT, [ADMIN, MANAGER, AGENT, BILLING]);
add(actions.CHANGE_USER_SIMO_CYCLE, [ADMIN, MANAGER]);
add(actions.CHANGE_USER_SIMO_ACCOUNT, [
  ADMIN,
  MANAGER,
  BUSINESS,
  BUSINESS_ADMIN,
  RESELLER,
  RESELLER_ADMIN,
]);

//address
add(actions.CREATE_ADDRESS, [
  ADMIN,
  MANAGER,
  AGENT,
  BILLING,
  BUSINESS,
  BUSINESS_ADMIN,
  RESELLER,
  RESELLER_ADMIN,
]);
addRule(actions.CREATE_ADDRESS, createAddressRule);
add(actions.EDIT_ADDRESS, [
  ADMIN,
  MANAGER,
  AGENT,
  BILLING,
  BUSINESS,
  BUSINESS_ADMIN,
  RESELLER,
  RESELLER_ADMIN,
]);
addRule(actions.EDIT_ADDRESS, editAddressRule);

// att
add(actions.SET_ATT_UPCOMING_PLAN, true);
add(actions.SET_ATT_PLAN, true);
add(actions.UPGRADE_ATT_INVOICE, [
  ADMIN,
  MANAGER,
  BILLING,
  BUSINESS,
  BUSINESS_ADMIN,
]);
add(actions.EXPIRE_ATT_SUB, [ADMIN]);
add(actions.UPDATE_ATT_DEVICE, true);
add(actions.ACTIVATE_ATT_SUB, true);
add(actions.SUSPEND_ATT_SUB, true);
addRule(actions.SUSPEND_ATT_SUB, attRestoreSuspendResellerRule);
add(actions.RESTORE_ATT_SUB, true);
addRule(actions.RESTORE_ATT_SUB, attRestoreSuspendResellerRule);
add(actions.ADD_ATT_LEASE, true);
add(actions.CHANGE_ATT_MDN, [ADMIN]);
add(actions.TRANSFER_ATT_SUB, [ADMIN, MANAGER]);
add(actions.VIEW_ATT_VERIFICATION_CODE, [
  ADMIN,
  AGENT,
  MANAGER,
  BILLING,
  BUSINESS,
  BUSINESS_ADMIN,
]);
add(actions.SEARCH_ATT_SUB_BY_IMSI, [ADMIN]);

// simo sub
add(actions.SET_SIMO_PLAN, true);
add(actions.SET_SIMO_UPCOMING_PLAN, true);
add(actions.UPGRADE_SIMO_INVOICE, [ADMIN, MANAGER, BILLING]);
add(actions.ACTIVATE_SIMO_SUB, true);
add(actions.CHANGE_SIMO_AUTO_RENEW, true);
add(actions.EXPIRE_SIMO_SUB, [ADMIN]);
add(actions.SET_SIMO_IMMEDIATE_RENEWAL, true);

// simo device
add(actions.UPDATE_SIMO_DEVICE, true);
add(actions.CHANGE_SIMO_ACCOUNT, true);
add(actions.EXPIRE_SIMO_DEVICE, [ADMIN]);
add(actions.SUSPEND_SIMO_DEVICE, true);
add(actions.RESTORE_SIMO_DEVICE, true);
add(actions.TRANSFER_SIMO_DEVICE, [ADMIN, MANAGER]);

// quick
add(actions.SET_QUICK_UPCOMING_PLAN, true);
add(actions.SET_QUICK_PLAN, true);
add(actions.UPGRADE_QUICK_INVOICE, [
  ADMIN,
  MANAGER,
  BILLING,
  BUSINESS,
  BUSINESS_ADMIN,
  BUSINESS_AGENT,
]);
add(actions.EXPIRE_QUICK_SUB, [ADMIN]);
add(actions.UPDATE_QUICK_DEVICE, true);
add(actions.SUSPEND_QUICK_SUB, [
  ADMIN,
  BILLING,
  BUSINESS,
  BUSINESS_ADMIN,
  BUSINESS_AGENT,
  RESELLER,
]);
add(actions.RESTORE_QUICK_SUB, [
  ADMIN,
  MANAGER,
  BILLING,
  BUSINESS,
  BUSINESS_ADMIN,
  BUSINESS_AGENT,
  RESELLER,
]);
add(actions.GET_QUICK_USAGE, true);
add(actions.CHANGE_QUICK_VOICEMAIL_PIN, true);
add(actions.DELETE_QUICK_VOICEMAIL_PIN, true);
add(actions.CHANGE_QUICK_CALLER_ID, true);
add(actions.CHANGE_QUICK_MDN, [ADMIN, MANAGER]);
add(actions.ACTIVATE_QUICK_SUB, [
  ADMIN,
  AGENT,
  MANAGER,
  BILLING,
  RESELLER,
  BUSINESS,
  BUSINESS_ADMIN,
  BUSINESS_AGENT,
]);
add(actions.SET_QUICK_SERVICE_ADDRESS, true);
add(actions.UPDATE_QUICK_STATUS, [ADMIN, MANAGER]);
add(actions.UPDATE_QUICK_SERVICE_CODES, true);
add(actions.REACTIVATE_QUICK_SUB, [ADMIN]);
add(actions.VIEW_QUICK_VERIFICATION_CODE, [
  ADMIN,
  AGENT,
  MANAGER,
  BILLING,
  RESELLER,
]);
add(actions.TRANSFER_QUICK_SUB, [ADMIN, MANAGER]);
add(actions.CREATE_QUICK_NEW_PORT, true);

// payment methods
add(actions.CREATE_PAYMENT_METHOD, true);
add(actions.UPDATE_PAYMENT_METHOD, [
  ADMIN,
  MANAGER,
  AGENT,
  BUSINESS,
  BUSINESS_ADMIN,
]);
add(actions.DELETE_PAYMENT_METHOD, [ADMIN, MANAGER, AGENT]);
add(actions.SET_DEFAULT_PAYMENT_METHOD, [
  ADMIN,
  MANAGER,
  AGENT,
  RESELLER,
  BUSINESS,
  BUSINESS_ADMIN,
]);
add(actions.VIEW_PAYMENT_METHODS, [
  ADMIN,
  ADMIN_RO,
  MANAGER,
  AGENT,
  RESELLER,
  BUSINESS,
  BUSINESS_ADMIN,
  RESELLER_ADMIN,
]);

//purchases
add(actions.VIEW_PURCHASES, [
  ADMIN,
  ADMIN_RO,
  MANAGER,
  AGENT,
  RESELLER,
  BUSINESS,
  BUSINESS_ADMIN,
  RESELLER_ADMIN,
]);
add(actions.CREATE_RENEWAL_INVOICE, [
  ADMIN,
  MANAGER,
  AGENT,
  RESELLER,
  BUSINESS,
  BUSINESS_ADMIN,
  RESELLER_ADMIN,
]);
add(actions.SET_OVERDUE_PURCHASE, [ADMIN, MANAGER, BILLING]);
add(actions.ALLOCATE_LINEITEMS, [ADMIN, MANAGER, BILLING]);

//custom plans
add(actions.VIEW_CUSTOM_PLAN_PRICING, [ADMIN, ADMIN_RO, MANAGER]);
add(actions.MODIFY_CUSTOM_PLAN, [ADMIN]);

//prices
add(actions.VIEW_PRICES, [
  ADMIN,
  ADMIN_RO,
  AGENT,
  MANAGER,
  BUSINESS,
  BUSINESS_ADMIN,
  RESELLER,
  RESELLER_ADMIN,
]);

const permissions = getPerms();

export default permissions;
